import { combineReducers } from '@reduxjs/toolkit';

import { namePlacement } from '../../common/placement_reducers/namePlacement'; // dropdown values
import { typePlacement } from '../../common/placement_reducers/typePlacement'; // dropdown values

import { placementAll } from './all/placementAll';
import { placementAllList } from './all/placementAllList';
import { placementNoAccount } from './all/placementNoAccount';
import { placementNoAccountList } from './all/placementNoAccountList';

import { placement } from './core/placement';
import { placementList } from './core/placementList';

export default combineReducers({
    typePlacement,
    namePlacement,

    placementNoAccount,
    placementNoAccountList,

    placementAll,
    placementAllList,

    placement,
    placementList,
});
